import Button from 'lego-framework/src/components/Button';
import Modal from 'lego-framework/src/containers/Modal';
import DeleteModal from '../components/DeleteModal';
import Tabs from 'lego-framework/src/containers/Tabs';
import Tab from 'lego-framework/src/containers/Tab';
import ClickOutside from 'lego-framework/src/directives/click-outside';
import FormInput from 'lego-framework/src/forms/FormInput';
import FormMaskInput from 'lego-framework/src/forms/FormMaskInput';
import FormTextArea from 'lego-framework/src/forms/FormTextArea';
import FormSelect from 'lego-framework/src/forms/FormSelect';
import FormDatePicker from 'lego-framework/src/forms/FormDatePicker';
import FormCheckbox from 'lego-framework/src/forms/FormCheckbox';
import FormFileInput from 'lego-framework/src/forms/FormFileInput';
import FormAjaxSelect from 'lego-framework/src/forms/FormAjaxSelect';

import Form from 'lego-framework/src/forms/PostForm';
import SimpleForm from 'lego-framework/src/forms/SimpleForm';

import VueTable from 'lego-framework/src/tables/VueTable';
import SimpleTable from 'lego-framework/src/tables/SimpleTable';
import VueTableCard from 'lego-framework/src/tables/VueTableCard';
import SectionHeading from '../components/ui/SectionHeading';

import ErrorIcon from 'lego-framework/src/svg-icons/ErrorIcon';
import SuccessIcon from 'lego-framework/src/svg-icons/SuccessIcon';
import LoadingAnimation from 'lego-framework/src/svg-icons/LoadingAnimation';
import DropdownButton from '../components/DropdownButton';
import CustomFormFileInput from '../components/CustomFormFileInput';

import * as validator from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/en.json';

import EditButton from 'lego-framework/src/components/EditButton';
import DeleteButton from 'lego-framework/src/components/DeleteButton';
import SaveButton from 'lego-framework/src/components/SaveButton';

import AjaxView from 'lego-framework/src/ajax/AjaxView';
import ImageInfo from '../components/ImageInfo';
import CustomDropdownButton from '../components/CustomDropdownButton';

import NotificationsPlugin from 'lego-framework/src/notification';

export default {
    install: function (Vue) {
        Vue.use(ClickOutside);
        Vue.use(NotificationsPlugin);

        Vue.component('image-info', ImageInfo);
        Vue.component('custom-drop-btn', CustomDropdownButton);
        Vue.component('btn', Button);
        Vue.component('edit-btn', EditButton);
        Vue.component('delete-btn', DeleteButton);
        Vue.component('save-btn', SaveButton);
        Vue.component('tabs', Tabs);
        Vue.component('tab', Tab);
        Vue.component('modal', Modal);
        Vue.component('delete-modal', DeleteModal);
        Vue.component('drop-btn', DropdownButton);

        Vue.component('b-form', Form);
        Vue.component('s-form', SimpleForm);

        Vue.component('validated-input', FormInput);
        Vue.component('validated-text-area', FormTextArea);
        Vue.component('validated-mask-input', FormMaskInput);
        Vue.component('validated-select', FormSelect);
        Vue.component('validated-vue-select', FormSelect);
        Vue.component('validated-date-picker', FormDatePicker);
        Vue.component('validated-checkbox', FormCheckbox);
        Vue.component('file-input', FormFileInput);
        Vue.component('custom-file-input', CustomFormFileInput);
        Vue.component('validated-ajax-vue-select', FormAjaxSelect);

        Vue.component('vue-table', VueTable);
        Vue.component('vue-table-card', VueTableCard);
        Vue.component('simple-table', SimpleTable);

        Vue.component('error-icon', ErrorIcon);
        Vue.component('success-icon', SuccessIcon);
        Vue.component('loading-animation', LoadingAnimation);
        Vue.component('section-heading', SectionHeading);

        Vue.component('ajax-view', AjaxView);

        Vue.component('validation-provider', validator.ValidationProvider);
        Vue.component('validation-observer', validator.ValidationObserver);

        Object.keys(rules).forEach(rule => {
            validator.extend(rule, {
                ...rules[rule], // copies rule configuration
                message: messages[rule] // assign message
            });
        });
    }
};
